import { render, staticRenderFns } from "./Segmented.vue?vue&type=template&id=19461230&scoped=true"
import script from "./Segmented.vue?vue&type=script&lang=js"
export * from "./Segmented.vue?vue&type=script&lang=js"
import style0 from "./Segmented.vue?vue&type=style&index=0&id=19461230&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19461230",
  null
  
)

export default component.exports